import { render, staticRenderFns } from "./AssociationsComponent.vue?vue&type=template&id=c3cf4df0&scoped=true"
import script from "./AssociationsComponent.vue?vue&type=script&lang=js"
export * from "./AssociationsComponent.vue?vue&type=script&lang=js"
import style0 from "./AssociationsComponent.vue?vue&type=style&index=0&id=c3cf4df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cf4df0",
  null
  
)

export default component.exports